import React from 'react';
import { Github, Twitter, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zen-text text-white py-20 px-6" data-id="element-42">
      <div className="max-w-4xl mx-auto text-center" data-id="element-43">
        <h2 className="text-4xl md:text-6xl font-moon-dance mb-8 text-zen-accent" data-id="element-44">
          "The journey is the destination."
        </h2>

        <div className="flex justify-center gap-8 mb-12" data-id="element-45">
          {[Github, Twitter, Linkedin, Instagram].map((Icon, index) => <a key={index} href="#" className="p-3 bg-white/5 rounded-full hover:bg-zen-accent hover:text-white transition-all duration-300 hover:-translate-y-1" data-id="element-46">
              <Icon size={20} data-id="element-47" />
            </a>)}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-white/40" data-id="element-48">
          <p data-id="element-49">&copy; 2024 Anjali Portfolio. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-50">
            <a href="#" className="hover:text-white transition-colors" data-id="element-51">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-52">
              Terms
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-53">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}